var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPointer = function SvgPointer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.95 3.57a.653.653 0 0 0-.833-.855L3.427 7.8a.653.653 0 0 0-.003 1.224L9.23 11.2a.5.5 0 0 1 .297.305l1.861 5.384a.653.653 0 0 0 1.224.03l5.34-13.35Zm-1.18-1.793c1.344-.499 2.643.833 2.11 2.164L13.54 17.29c-.568 1.42-2.597 1.373-3.097-.074l-1.785-5.162L3.073 9.96c-1.432-.537-1.43-2.565.005-3.098z",
    clipRule: "evenodd"
  })));
};
export default SvgPointer;